import { Box } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';
import { STextProps } from '@setvi/shared/components/sui/stext';
import { CSSProperties, useState } from 'react';
import { Price } from '../products-list/useProductColumns/contents/price';

interface PriceButtonProps {
  price: number;
  highlight?: boolean;
  prefix?: string;
  weight?: STextProps['weight'];
  size?: STextProps['size'];
  customLoader?: JSX.Element;
  loading?: boolean;
  style?: CSSProperties;
  onGetPrice: () => Promise<void>;
}

export const PriceButton = ({
  price,
  highlight = false,
  loading: priceLoading = false,
  prefix = '',
  weight,
  size,
  style,
  customLoader,
  onGetPrice
}: PriceButtonProps) => {
  const [loading, setLoading] = useState<boolean>(priceLoading);

  const handleGetPrice = async () => {
    setLoading(true);
    try {
      await onGetPrice();
    } finally {
      setLoading(false);
    }
  };

  if (price || (typeof price === 'number' && price === 0))
    return (
      <Box display="flex" alignItems="center">
        <Price
          style={style}
          value={price}
          prefix={prefix}
          weight={weight}
          size={size}
          highlight={highlight}
        />
      </Box>
    );

  if (loading && customLoader) return customLoader;

  return (
    <SButton
      loading={loading}
      onClick={e => {
        e.stopPropagation();
        handleGetPrice();
      }}
      style={{ width: 'max-content', ...style }}
      variant="outlined">
      Get Price
    </SButton>
  );
};
